<script>
import { VCombobox } from 'vuetify/lib';
import BReadOnlyTextField from '../BReadOnlyTextField';
import ValidationField from "@/components/base_components/ValidationField";
export default {
  props: {
    ...VCombobox.options.props,
    readOnly: {
      type: Boolean,
      defalut: false
    },
    formRef: String
  },
  render(createElement) {
    const self = this;
    if (!self.$props.readOnly) {
      const customData = {
        class: { 'b-combobox--input--has-label': self.$props.label },
        props: {
          ...self.$props,
          outlined: true,
          dense: true,
          hideDetails: 'auto'
        },
        on: {
          ...self.$listeners
        },
        nativeOn: {
          change: event => self.$emit('change', event.target.value),
          input: event => self.$emit('input', event.target.value)
        }
      };

      const slots = Object.entries(this.$slots).map(([slotName, slotContent]) =>
        createElement('template', { slot: slotName }, slotContent)
      );

      const slot = ({ error, deleteServerError }) => {
        customData.props.errorMessages = error;
        customData.on = {
          keyup: () => deleteServerError(),
          input: () => deleteServerError(),
        }
        return createElement(VCombobox, customData, slots);
      }

      return createElement(ValidationField,
          {
            props: {
              uuid: this.$props.uuid,
              propPath: this.$props.propPath,
              formRef: this.$props.formRef
            },
            scopedSlots: { default: slot }
          });
    } else {
      return createElement(BReadOnlyTextField, { props: self.$props });
    }
  }
};
</script>

<style lang="scss">
.b-combobox--input--has-label {
  & > .v-input__control {
    padding-top: 4px;
  }
}
</style>
